import classNames from 'classnames';
import React from 'react';
import { Lorem, LoremLengths, WindowSizes } from '../../utils/constants';

import './LoremComponent.scss';

interface IProps {
  loremLength: string;
  windowSize: WindowSizes;
}

const LoremComponent = ({ loremLength, windowSize }: IProps) => {
  if (loremLength === LoremLengths.None) {
    return null;
  }
  let loremContent;
  if (loremLength === LoremLengths.Long) {
    loremContent = Lorem.Long;
  }
  if (loremLength === LoremLengths.Short) {
    if (windowSize === WindowSizes.Large) {
      loremContent = Lorem.Short;
    }
    if (windowSize === WindowSizes.Medium || windowSize === WindowSizes.Small) {
      loremContent = Lorem.Shorter;
    }
  }
  return (
    <div
      className={classNames('Lorem', { collapsible: loremLength === LoremLengths.Long })}
      aria-hidden="true" // Hide from screen readers because it is not important content
    >
      {loremContent &&
        loremContent.map((loremPiece) => (
          <p key={loremPiece}>
            <span>{loremPiece}</span>
          </p>
        ))}
    </div>
  );
};

export default LoremComponent;
